import { Col, Row } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import dayjs from 'dayjs';
import React from 'react';

import ContentCard from 'components/atoms/ContentCard';
import Title from 'components/atoms/Title';
import TranslateText from 'components/hoc/TranslateText';

import { ILeiInfo } from 'services/lei/PrehledUctu';

import { ELeiGleifStav } from 'enums/lei/leiGleifStav';

interface ISpracovaneLeiCard extends ButtonProps {
    ucet: ILeiInfo;
    onClick?: () => void;
}

const SpracovaneLeiCard: React.FC<ISpracovaneLeiCard> = props => {
    const { ucet, onClick } = props;
    return (
        <ContentCard
            title={ucet.nazev || '—'}
            onButtonclick={onClick}
            mainPageStyle={true}
            disabled={ucet.stavlei === ELeiGleifStav.TRANSFERRED || ucet.stavlei === ELeiGleifStav.CANCELLED}
        >
            {ucet.lei && ucet.stavlei !== ELeiGleifStav.PENDING_VALIDATION ? (
                <Row>
                    <Col span={24}>
                        <Title text="LEI_VELKE" level={5} />
                    </Col>
                    <Col span={24}>
                        <p>{ucet.lei}</p>
                    </Col>
                    {ucet.stavlei !== ELeiGleifStav.TRANSFERRED && ucet.stavlei !== ELeiGleifStav.CANCELLED ? (
                        <>
                            <Title text="LEI_STAV_GLEIF" level={5} />
                            <Col span={24}>
                                <p>
                                    <TranslateText>
                                        {ucet.stavlei ? 'LEI_GLEIF_STAV_' + ucet.stavlei : 'GLEIF_NEVEDENO'}
                                    </TranslateText>
                                </p>
                            </Col>
                            {ucet.poslzmeny && (
                                <>
                                    <Title text="LEI_POSLEDNA_ZMENA" level={5} />
                                    <Col span={24}>
                                        <p>{dayjs(ucet.poslzmeny).format('DD.MM.YYYY')}</p>
                                    </Col>
                                </>
                            )}
                            {ucet.termincertifiakce && (
                                <>
                                    <Title text="LEI_NEXT_CERT" level={5} />
                                    <Col span={24}>
                                        <p>{dayjs(ucet.termincertifiakce).format('DD.MM.YYYY')}</p>
                                    </Col>{' '}
                                </>
                            )}
                        </>
                    ) : (
                        <Title
                            text={
                                ucet.stavlei === ELeiGleifStav.TRANSFERRED
                                    ? 'LEI_CARD_TRANSFERED'
                                    : 'EMISE_PODZAD_STAV_ZRUSENO'
                            }
                            level={5}
                        />
                    )}
                </Row>
            ) : (
                <Row>
                    <Col span={24}>
                        <Title text="LEI_IDENTIFIKATOR" level={5} />
                    </Col>
                    <Col span={24}>
                        <p>{ucet.varsymbol}</p>
                    </Col>
                    {ucet.stavlei !== ELeiGleifStav.CANCELLED ? (
                        <>
                            <Title text="LEI_STAV_GLEIF" level={5} />
                            <Col span={24}>
                                <p>
                                    <TranslateText>
                                        {ucet.stavlei ? 'LEI_GLEIF_STAV_' + ucet.stavlei : 'GLEIF_NEVEDENO'}
                                    </TranslateText>
                                </p>
                            </Col>
                            <Title text="LEI_PROBIHA" level={5} />
                            <Col span={24}>
                                <TranslateText>{`LEI_STAVUCTU_${ucet.stav || 'ROZP'}`}</TranslateText>
                            </Col>
                        </>
                    ) : (
                        <Title text="LEI_CANCELLED_CARD_TEXT" level={5} />
                    )}
                </Row>
            )}
        </ContentCard>
    );
};

export default SpracovaneLeiCard;
